import { Injectable } from '@angular/core';
import { Action, Selector, State, StateContext } from '@ngxs/store';
import { HttpService } from '../../core/services/http/http.service';
import { IMercadoRelevante } from '../../core/interfaces/relevant-markets.interface';
import {
  AddRelevantMarketAction,
  DeleteRelevantMarketAction,
  GetAllRelevantMarketsAction,
  UpdatedRelevantMarketAction,
} from './relevant-markets.actions';
import { EnovaAlertsComponent } from '../../core/utils/enova-alerts/enova-alerts.component';
import { MatDialog } from '@angular/material/dialog';

export interface RelevantMarketsStateModel {
  relevantMarkets: IMercadoRelevante[];
}

@State<RelevantMarketsStateModel>({
  name: 'relevantMarkets',
  defaults: {
    relevantMarkets: [],
  },
})
@Injectable()
export class RelevantMarketsState {
  @Selector() static GetAllData(
    state: RelevantMarketsStateModel
  ): IMercadoRelevante[] {
    return state?.relevantMarkets ? state?.relevantMarkets : [];
  }

  constructor(
    private httpService: HttpService,
    public dialog: MatDialog
  ) {}

  @Action(GetAllRelevantMarketsAction)
  async GetAllRelevantMarketsAction(
    ctx: StateContext<RelevantMarketsStateModel>
  ) {
    try {
      const resp = await this.httpService.getRelevantMarkets();

      ctx.patchState({
        relevantMarkets: resp,
      });
    } catch (error) {
      this.dialog.open(EnovaAlertsComponent, {
        width: 'auto',
        data: {
          type: 'error',
          hiddeCancelBtn: true,
        },
      });
    }
  }

  @Action(AddRelevantMarketAction)
  async AddRelevantMarketAction(
    ctx: StateContext<RelevantMarketsStateModel>,
    { payload }: AddRelevantMarketAction
  ) {
    return this.httpService
      .postRelevantMarket(payload)
      .then(() => {
        this.dialog.open(EnovaAlertsComponent, {
          width: 'auto',
          data: {
            type: 'success',
            text: '¡El mercado relevante se ha creado de forma exitosa!',
            hiddeCancelBtn: true,
          },
        });
        ctx.dispatch(new GetAllRelevantMarketsAction());
      })
      .catch(() => {
        this.dialog.open(EnovaAlertsComponent, {
          width: 'auto',
          data: {
            type: 'error',
            hiddeCancelBtn: true,
          },
        });
      });
  }

  @Action(UpdatedRelevantMarketAction)
  async UpdatedRelevantMarketAction(
    ctx: StateContext<RelevantMarketsStateModel>,
    { payload }: UpdatedRelevantMarketAction
  ) {
    return this.httpService
      .updateRelevantMarket(payload)
      .then(() => {
        this.dialog.open(EnovaAlertsComponent, {
          width: 'auto',
          data: {
            type: 'success',
            text: '¡El mercado relevante se ha actualizado de forma exitosa!',
            hiddeCancelBtn: true,
          },
        });
        ctx.dispatch(new GetAllRelevantMarketsAction());
      })
      .catch(() => {
        this.dialog.open(EnovaAlertsComponent, {
          width: 'auto',
          data: {
            type: 'error',
            hiddeCancelBtn: true,
          },
        });
      });
  }

  @Action(DeleteRelevantMarketAction)
  async DeleteRelevantMarketAction(
    ctx: StateContext<RelevantMarketsStateModel>,
    { payload }: DeleteRelevantMarketAction
  ) {
    return this.httpService
      .deleteRelevantMarket(payload)
      .then(() => {
        this.dialog.open(EnovaAlertsComponent, {
          width: 'auto',
          data: {
            type: 'success',
            text: '¡El mercado relevante se ha eliminado de forma exitosa!',
            hiddeCancelBtn: true,
          },
        });
        ctx.dispatch(new GetAllRelevantMarketsAction());
      })
      .catch(() => {
        this.dialog.open(EnovaAlertsComponent, {
          width: 'auto',
          data: {
            type: 'error',
            hiddeCancelBtn: true,
          },
        });
      });
  }
}
